import styled                 from 'styled-components';
import { menuTagColor } from 'Public/Css/colors';

export default styled.span`
    a {
        color: ${menuTagColor};
    }
`;
